<template>
<div class="page_home_download col-lg-8 mb-8">

    <!-- title -->
    <v-chip class="font-size:3rem;" text-color="white" color="primary">資料下載</v-chip>
    <br><br>

    <!-- Lists -->
    <v-list>
        <v-subheader>宣導手冊</v-subheader>
        <v-list-tile
        v-for="file in manuals"
        :key="file.name"
        :href="`/download/${file.name}.pdf`"
        target="_blank"
        ripple
        >
        <v-list-tile-content>
            <v-list-tile-title>{{ file.name }}</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
            <v-subheader inset>{{ file.size }}</v-subheader>
        </v-list-tile-action>
        </v-list-tile>

        <v-divider></v-divider>

        <v-subheader>方案介紹</v-subheader>
        <v-list-tile
        v-for="file in files2"
        :key="file.name"
        :href="`/download/${file.name}.pdf`"
        target="_blank"
        ripple
        >
        <v-list-tile-content>
            <v-list-tile-title>{{ file.name }}</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
            <v-subheader inset>{{ file.size }}</v-subheader>
        </v-list-tile-action>
        </v-list-tile>
    </v-list>
    
</div>
</template>

<script>
import manuals from '../../../generated/manual-manifest.json'

export default {
    data() {
        return {
            manuals,
            files2: [
                { name: '100學年度大學多元入學方案介紹', size: '239KB', },
                { name: '100學年度大學多元入學家長說明會', size: '3.92MB', },
                { name: '100學年度大學甄選入學招生試務作業介紹', size: '724KB', },
                { name: '100學年度繁星推薦高中作業概況介紹', size: '1.25MB', },
            ],
        }
    },
}
</script>

<style lang="scss">
.page_home_download {
    .v-list a {
        text-decoration: none;
    }
    .v-chip__content {
        font-size: 1.5rem;
    }
}
</style>
